/* eslint-disable camelcase */
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getOrders = async (params) => {
  try {
    const { currentPage, itemsPerPage, order_date_from, order_date_to, status, sort, shop_name, keyword } = params;
    const skip = (currentPage - 1) * itemsPerPage;
    let queryObj = {
      skip,
      limit: itemsPerPage,
      order_date_from,
      order_date_to
    };
    if (status !== undefined) {
      queryObj.status = status;
    }
    let queryString = '';
    // Build query string manually to support sort like sesProductService
    queryString += `&limit=${itemsPerPage || 20}&skip=${skip || 0}`;
    if (order_date_from) queryString += `&order_date_from=${order_date_from}`;
    if (order_date_to) queryString += `&order_date_to=${order_date_to}`;
    if (status !== undefined) queryString += `&status=${status}`;
    if (shop_name) queryString += `&shop_name=${shop_name}`;
    if (keyword) queryString += `&keyword=${encodeURIComponent(keyword)}`;
    if (sort) queryString += `&sort=${sort}`;
    queryString = '?' + queryString.replace('?&', '?');
    const url = `${getApiUrl()}/api/order/get-orders${queryString}`;
    console.log('Request URL:', url); // Debug log
    const response = await API.get(url);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const updateOrders = async (orders) => {
  console.log('orders', orders);
  try {
    const response = await API.post(`${getApiUrl()}/api/order`, orders);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSaleTeamStatus = async (params) => {
  try {
    const { startDate, endDate } = params;
    let queryString = '';
    if (startDate) queryString += `?startDate=${encodeURIComponent(startDate)}`;
    if (endDate) queryString += `${queryString ? '&' : '?'}endDate=${encodeURIComponent(endDate)}`;
    const url = `${getApiUrl()}/api/order/sales-team-stats${queryString}`;
    const response = await API.get(url);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getFulfillTeamStat = async (params) => {
  try {
    const { startDate, endDate } = params;
    let queryString = '';
    if (startDate) queryString += `?startDate=${encodeURIComponent(startDate)}`;
    if (endDate) queryString += `${queryString ? '&' : '?'}endDate=${encodeURIComponent(endDate)}`;
    const url = `${getApiUrl()}/api/order/fulfill-team-stats${queryString}`;
    const response = await API.get(url);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const orderService = {
  getOrders,
  updateOrders,
  getSaleTeamStatus,
  getFulfillTeamStat
};
